import React from 'react';
import Typography from '@material-ui/core/Typography';

const RequestInfo = ({ reservationRequest }) => (
    <>
        <Typography variant="h6" gutterBottom>
            Request
        </Typography>
        <Typography variant="body1" gutterBottom>
            Request Type: <b>{reservationRequest.category}</b>
        </Typography>
        <Typography variant="body2" gutterBottom>
            Created: <b>{new Date(reservationRequest.createDate).toDateString()}</b>
        </Typography>
        {
            reservationRequest.assignedDate ?
                <Typography variant="body2" gutterBottom>
                    Assigned: <b>{reservationRequest.assignedDate.substring(0, 10)}</b>
                </Typography>
                : null
        }
        <Typography variant="h6" gutterBottom>
            Offers
        </Typography>
        <Typography variant="body2" gutterBottom>
            <b>{reservationRequest.noofAppliedOffers}</b> Applied Offers
        </Typography>
    </>
);

export default RequestInfo;